export const createHeadline = ({ headlineTitle }) => headlineTitle || 'Lingerie';
